import React, { createContext, useState, useEffect } from "react";
import {
  viewAdminDetail,
  deactiveAdminApi,
  activeAdminApi,
  inviteActiveAdminApi,
  deleteUserApi,
} from "../../../api/Api";
import { useCookies } from "react-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import RouteConstants from "../../../constants/routeConstants.json";
import ContentData from "../../../constants/contentFile.json";
import { handleApiError } from "../../../constants/Constants";

export const AdminManageViewContext = createContext({});
export const AdminManageContextProvider = ({ children }) => {
  const location = useLocation();
  const [adminData, setAdminData] = useState("");
  const [deletePopup, setDeletePopup] = useState(false);
  const [statusPopup, setStatusPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState("");
  const [successPopup, setSuccessPopup] = useState(false);
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [successPopupMessage, setSuccessPopupMessage] = useState("");
  const [productCategoryList, setProductCategoryList] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [buttonText, setButtonText] = useState("");
  const [statusValue, setStatusValue] = useState(0);
  const [deactiveAlert, setDeactiveAlert] = useState(false);
  const [activeAlert, setActiveAlert] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [deleteAlert, setDeleteAlert] = useState(false);

  const adminId = location?.state?.id;
  const currentPage = location?.state?.page;
  const navigate = useNavigate();

  const permissionAccess = JSON.parse(
    localStorage.getItem("permissions")
  )?.filter((item) => {
    return item.feature === "66f506fa5a192b6c70a82cd8";
  })[0];

  const viewAdmin = async (id) => {
    try {
      setSpinnerStatus(true);
      const getDetailData = await viewAdminDetail(id);
      if (getDetailData.status === 200) {
        setSpinnerStatus(false);
        setErrorPopup(false);
        setAdminData(getDetailData.data.data.user);
      }
    } catch (error) {
      if (error?.status === 404) {
        setErrorPopupMessage("");
        setErrorPopup(false);
        adminTableList();
      } else {
        handleApiError(
          error,
          setStatusValue,
          setErrorPopupMessage,
          setErrorPopup,
          setButtonText
        );
      }
    }
    setSpinnerStatus(false);
  };

  const deactiveAdminData = async (id) => {
    try {
      setSpinnerStatus(true);
      const getrole = await deactiveAdminApi(id);
      if (getrole.data.statusCode === 200) {
        setDeactiveAlert(false);
        setSuccessPopup(true);
        setDeletePopup(false);
        setSpinnerStatus(false);
        setStatusPopup(false);
        setErrorPopup(false);
        setSuccessPopupMessage(getrole.data.message);
      }
    } catch (error) {
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
      setDeletePopup(false);
      setDeactiveAlert(false);
    }
    setSpinnerStatus(false);
  };

  const inviteActiveAdmin = async (id) => {
    try {
      setSpinnerStatus(true);
      const getrole = await inviteActiveAdminApi(id);
      if (getrole.data.statusCode === 200) {
        setActiveAlert(false);
        setSuccessPopup(true);
        setDeletePopup(false);
        setSpinnerStatus(false);
        setStatusPopup(false);
        setErrorPopup(false);
        setSuccessPopupMessage(getrole.data.message);
      }
    } catch (error) {
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
      setDeletePopup(false);
      setActiveAlert(false);
    }
    setSpinnerStatus(false);
  };

  const activeAdminData = async (id) => {
    try {
      setSpinnerStatus(true);
      const getrole = await activeAdminApi(id);
      if (getrole.data.statusCode === 200) {
        setActiveAlert(false);
        setSuccessPopup(true);
        setDeletePopup(false);
        setSpinnerStatus(false);
        setStatusPopup(false);
        setErrorPopup(false);
        setSuccessPopupMessage(getrole.data.message);
      }
    } catch (error) {
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
      setDeletePopup(false);
      setActiveAlert(false);
    }
    setSpinnerStatus(false);
  };

  // delete user
  const deleteAdmin = async (id) => {
    try {
      setSpinnerStatus(true);
      const getrole = await deleteUserApi(id);
      if (getrole.data.statusCode === 200) {
        setDeleteAlert(false);
        setSuccessPopup(true);
        setDeletePopup(false);
        setSpinnerStatus(false);
        setStatusPopup(false);
        setErrorPopup(false);
        setSuccessPopupMessage(getrole.data.message);
      }
    } catch (error) {
      setDeletePopup(false);
      setDeleteAlert(false);
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
    }
    setSpinnerStatus(false);
  };

  useEffect(() => {
    viewAdmin(adminId);
  }, []);

  const adminToLogin = () => {
    navigate(RouteConstants.LOGIN);
    removeCookie("x-access-token");
  };

  const adminTableList = () => {
    navigate(RouteConstants.ADMIN_LIST, { state: { page: currentPage } });
  };

  const editAdminData = (id) => {
    navigate(RouteConstants.EDIT_ADMIN, { state: { id, page: currentPage } });
  };

  const providerValue = {
    adminData,
    deletePopup,
    errorPopup,
    errorPopupMessage,
    setDeletePopup,
    setStatusPopup,
    spinnerStatus,
    statusPopup,
    productCategoryList,
    setSuccessPopup,
    successPopup,
    categoryData,
    successPopupMessage,
    deactiveAdminData,
    setErrorPopup,
    inviteActiveAdmin,
    adminId,
    adminTableList,
    adminToLogin,
    viewAdmin,
    statusValue,
    buttonText,
    editAdminData,
    setDeactiveAlert,
    deactiveAlert,
    activeAdminData,
    setActiveAlert,
    activeAlert,
    permissionAccess,
    deleteAdmin,
    deleteAlert,
    setDeleteAlert,
  };
  return (
    <AdminManageViewContext.Provider value={providerValue}>
      {children}
    </AdminManageViewContext.Provider>
  );
};
